import * as z from "zod/v4";

const AeoResponseIdentifierSchema_ = z.object({
  sessionId: z.string(),
  sessionIndex: z.number(),
});

export const AeoResponseIdentifierSchema: z.ZodType<AeoResponseIdentifierSchema> =
  AeoResponseIdentifierSchema_;
export interface AeoResponseIdentifierSchema
  extends z.infer<typeof AeoResponseIdentifierSchema_> {}

const AeoResponseMetricSchema_ = z.object({
  sessionId: z.string(),
  sessionIndex: z.number(),
  sourceCount: z.number(),
  brandMentions: z.number(),
});

export const AeoResponseMetricSchema: z.ZodType<AeoResponseMetricSchema> =
  AeoResponseMetricSchema_;
export interface AeoResponseMetricSchema
  extends z.infer<typeof AeoResponseMetricSchema_> {}

export const getAeoResponseMetrics = {
  name: "getAeoResponseMetrics" as const,
  input: z.object({ responses: z.array(AeoResponseIdentifierSchema) }),
  output: z.object({ metrics: z.array(AeoResponseMetricSchema) }),
};
